import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Heading } from 'ext/components/ui';
import { AccountsList } from 'ext/components/AccountsList';
import StyleProvider from 'styles/StyleProvider';
import { Wrapper, Container, Header, Content, Description } from './styled';

/**
 * Full-screen account switcher component for use during initialization.
 * Shown when a user has no active account selected (Auth0 only).
 *
 * @param {object} props - Component props
 * @param {object} props.accounts - Object of accounts keyed by ID
 * @param {function} props.onSelect - Callback when an account is selected
 */
export function AccountSwitcherScreen({ accounts, onSelect }) {
  const [isPending, setIsPending] = useState(false);

  const handleSelect = useCallback(
    id => {
      if (!isPending) {
        setIsPending(true);
        onSelect(id);
      }
    },
    [isPending, onSelect]
  );

  return (
    <StyleProvider>
      <Wrapper>
        <Container>
          <Header>
            <Heading>Select an Account</Heading>
            <Description>
              Choose which account you would like to use with the Mobile
              Builder.
            </Description>
          </Header>

          <Content>
            <AccountsList
              accounts={accounts}
              selected={null}
              isPending={isPending}
              onSelect={handleSelect}
            />
          </Content>
        </Container>
      </Wrapper>
    </StyleProvider>
  );
}

AccountSwitcherScreen.propTypes = {
  accounts: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default AccountSwitcherScreen;
